"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatalakeTableNamesFromQuery = exports.generateDatalakeTableNameFromPrefixes = exports.extractEntitiesFromDatalakeTable = exports.isDatalakeTransformationOp = exports.isDatalakeTablePrefix = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const validate_1 = require("../validate");
const isLoanProductDatalakeTable = (tableName) => {
    return finley_types_1.DataLake.ONLY_LOAN_PRODUCT_DATALAKE_TABLE_NAME.some((prefix) => tableName.startsWith(prefix));
};
const isCreditFacilityDatalakeTable = (tableName) => {
    return finley_types_1.DataLake.ONLY_CREDIT_FACILITY_DATALAKE_TABLE_NAME.some((prefix) => tableName.startsWith(prefix));
};
const isLoanProductAndCreditFacilityDatalakeTable = (tableName) => {
    return finley_types_1.DataLake.LOAN_PRODUCT_AND_CREDIT_FACILITY_DATALAKE_TABLE_NAME.some((prefix) => tableName.startsWith(prefix));
};
const isFinancialStatementDatalakeTable = (tableName) => {
    return finley_types_1.DataLake.FINANCIAL_STATEMENT_ENTITY_PERIOD_DATALAKE_TABLE_NAME.some((prefix) => tableName.startsWith(prefix));
};
const isLimitedPartnerDatalakeTable = (tableName) => {
    return finley_types_1.DataLake.LIMITED_PARTNERS_ENTITY_CREDIT_FACILITY_SLUG_PARTITION_TABLES.some((prefix) => tableName.startsWith(prefix));
};
const isAthenaDatalakeOrgSuffixedView = (tableName) => {
    return finley_types_1.DataLake.ATHENA_VIEWS_ORG_SUFFIXED.some((prefix) => tableName.startsWith(prefix));
};
const DATALAKE_TABLE_DELIMITER = '_';
const isDatalakeTablePrefix = (input) => {
    return finley_types_1.DataLake.ALL_TABLE_PREFIXES.some((prefix) => prefix === input);
};
exports.isDatalakeTablePrefix = isDatalakeTablePrefix;
const isDatalakeTransformationOp = (input) => {
    const transformOps = _.values(finley_types_1.DataLake.TransformationOp);
    return transformOps.some((ops) => ops === input);
};
exports.isDatalakeTransformationOp = isDatalakeTransformationOp;
/**
 * Note that the extracted values are lower case since that's how
 * Datalake tables are set up
 */
const extractEntitiesFromDatalakeTable = (tableName) => {
    const splitTable = tableName.split(DATALAKE_TABLE_DELIMITER);
    // *** Credit Facility ***
    if (isCreditFacilityDatalakeTable(tableName)) {
        const lowerCaseCfSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseCfSlug, `Expected valid CF slug when extracting from CF Datalake table [tableName:${tableName}]`);
        return { creditFacilitySlugLowerCase: lowerCaseCfSlug };
    }
    // *** Loan Product ***
    if (isLoanProductDatalakeTable(tableName)) {
        const lowerCaseLpSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseLpSlug, `Expected valid LP slug when extracting from LP Datalake table [tableName:${tableName}]`);
        return { loanProductSlugLowerCase: lowerCaseLpSlug };
    }
    // *** Loan Product & Credit Facility ***
    if (isLoanProductAndCreditFacilityDatalakeTable(tableName)) {
        const lowerCaseCfSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseCfSlug, `Expected valid CF slug when extracting from LP & CF Datalake table [tableName:${tableName}]`);
        const lowerCaseLpSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseLpSlug, `Expected valid LP slug when extracting from LP & CF Datalake table [tableName:${tableName}]`);
        return {
            loanProductSlugLowerCase: lowerCaseLpSlug,
            creditFacilitySlugLowerCase: lowerCaseCfSlug,
        };
    }
    // *** Financial Statement Table: Org Slug ***
    if (isFinancialStatementDatalakeTable(tableName)) {
        // Table Name Example: "financial_statements_acmecorp"
        const orgSlugLowerCase = splitTable.pop();
        (0, common_1.finleyAssert)(orgSlugLowerCase, `Expected valid org slug when extracting from Financial Statement Datalake table [tableName:${tableName}]`);
        return { orgSlugLowerCase };
    }
    // *** Limited Partner Table ***
    if (isLimitedPartnerDatalakeTable(tableName)) {
        // Table Name Example: "limited_partners_acmecorp"
        const orgSlugLowerCase = splitTable.pop();
        (0, common_1.finleyAssert)(orgSlugLowerCase, `Expected valid org slug when extracting from Limited Partner Datalake table [tableName:${tableName}]`);
        return { orgSlugLowerCase };
    }
    throw new common_1.error.FinleyError(`Received unsupported Datalake [tableName:${tableName}] when trying to extract entity slug`);
};
exports.extractEntitiesFromDatalakeTable = extractEntitiesFromDatalakeTable;
// this is only exposed for the purposes of dependency breaking.
// at this point, we likely should not be adding additional callsights. preferably
// use getPossibleAthenaTableNamesForOrganizationId or getPossibleAthenaTableNamesForCreditFacilityId
// since these methods serve as the source of truth for table permissions
const generateDatalakeTableNameFromPrefixes = (params) => {
    const { tablePrefixes, orgSlug, creditFacilitySlugs, loanProductSlugs, creditFacilityBorrowerSlugs, } = params;
    const resultTableNames = new Set();
    for (const tablePrefix of tablePrefixes) {
        // *** Loan Product ***
        if (isLoanProductDatalakeTable(tablePrefix)) {
            loanProductSlugs.forEach((slug) => {
                resultTableNames.add(`${tablePrefix}_${slug}`.toLocaleLowerCase());
            });
        }
        // *** Credit Facility ***
        if (isCreditFacilityDatalakeTable(tablePrefix)) {
            creditFacilitySlugs.forEach((slug) => {
                resultTableNames.add(`${tablePrefix}_${slug}`.toLocaleLowerCase());
            });
        }
        // *** Loan Product & Credit Facility ***
        if (isLoanProductAndCreditFacilityDatalakeTable(tablePrefix)) {
            for (const lpSlug of loanProductSlugs) {
                for (const cfSlug of creditFacilitySlugs) {
                    resultTableNames.add(`${tablePrefix}_${lpSlug}_${cfSlug}`.toLocaleLowerCase());
                }
            }
        }
        // *** Financial Statement Tables ***
        if (isFinancialStatementDatalakeTable(tablePrefix)) {
            // orgs can access their own financial statement tables
            if (orgSlug) {
                resultTableNames.add(`${tablePrefix}_${orgSlug}`.toLocaleLowerCase());
            }
            // credit facility, lender (and borrower) has access to the borrower financial statement tables.
            creditFacilityBorrowerSlugs.forEach((creditFacilityBorrowerSlug) => {
                resultTableNames.add(`${tablePrefix}_${creditFacilityBorrowerSlug}`.toLocaleLowerCase());
            });
        }
        // *** Limited Partner Table ***
        if (isLimitedPartnerDatalakeTable(tablePrefix)) {
            // orgs can access their own limited partner tables.
            if (orgSlug) {
                resultTableNames.add(`${tablePrefix}_${orgSlug}`.toLocaleLowerCase());
            }
        }
        // *** Athena Views ***
        if (isAthenaDatalakeOrgSuffixedView(tablePrefix)) {
            // orgs can access their own views.
            if (orgSlug) {
                resultTableNames.add(`${tablePrefix}_${orgSlug}`.toLocaleLowerCase());
            }
        }
    }
    return Array.from(resultTableNames);
};
exports.generateDatalakeTableNameFromPrefixes = generateDatalakeTableNameFromPrefixes;
const getDatalakeTableNamesFromQuery = ({ queryString, }) => {
    // contains original finley table names as well as renamed/intermediate table names in the query
    const namesFromQuery = (0, validate_1.extractTableNamesFromQuery)(queryString);
    // filter for valid original table names
    return namesFromQuery.filter((name) => (0, validate_1.isFinleyAthenaTable)(name));
};
exports.getDatalakeTableNamesFromQuery = getDatalakeTableNamesFromQuery;
//# sourceMappingURL=index.js.map